module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/zh-hant/2-4464d6f41b7e249f0456b0e244511719.jpg";